export const mapToTimeZone = (tz: string): string => {
    try {
        Intl.DateTimeFormat(undefined, { timeZone: tz });
        return tz;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        return 'Etc/UTC';
    }
};
